module.exports = __webpack_public_path__ + "static/media/fullscreen.3b26ad37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/fullscreen.svg
// module id = 997
// module chunks = 0